import React, { useState } from "react";
import {
  Button,
  Dialog,
  Stack,
  TextField,
  Box,
  Typography,
  Divider,
} from "@mui/material";
import bankServices from "../../services/bankServices";
import { useSnackbar } from "notistack";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import { ManualKYCForm } from "../manualKycForm";

export default function CreateBankAccountModal({
  open,
  setOpen,
  panCardNumber,
  entityId,
  entityType,
  getBankAccountOfEntity,
}) {

  const [kycType, setKycType] = useState('auto');
  const [autoKycFailed, setAutoKycFailed] = useState(false)
  const [kycErrorMessage, setKycErrorMessage] = useState("");

  const setValidIKycType = () => {
    if (kycType === 'auto') {
      setKycType('manual')
    }
    else {
      setKycType('auto')
    }
  }

  const handleClose = () => {
    setOpen(false);
    // formik.resetForm();
  };

  // console.log("isAccountBeingAddedOnConfirmation" ,isAccountBeingAddedOnConfirmation)

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg" >
      <Box padding={1} >
        {kycType === 'auto' && <Stack>
          <AutoKYCForm entityId={entityId} open={open} setOpen={setOpen} entityType={entityType} getBankAccountOfEntity={getBankAccountOfEntity} setAutoKycFailed={setAutoKycFailed} setKycErrorMessage={setKycErrorMessage} />
          {/* <p>Auto kyc</p> */}
        </Stack>}
        {kycType === 'manual' && <Stack>
          <ManualKYCForm entityId={entityId} open={open} setOpen={setOpen} entityType={entityType} getBankAccountOfEntity={getBankAccountOfEntity} />
        </Stack>}


        {autoKycFailed && <Stack>

          {
            kycType === 'auto' &&
            <Typography color="error" variantMapping="p" align="justify" padding={1}>
              {kycErrorMessage || "Please check all the details once again or you can switch to manual kyc"}
            </Typography>
          }
          <Button
            variant="outlined"
            sx={{
              marginInline: "10px",
              // mt: { sm: 0, xs: 2 },
              width: { md: "auto", xs: "100%" },
              marginBottom: 1,  // Adjust spacing for this button
            }}
            onClick={() => setValidIKycType()}
          >
            {kycType === 'manual' ? "Switch Back to Auto KYC" : "Proceed to Manual KYC"}
          </Button>
        </Stack>
        }



      </Box>


    </Dialog>
  );
}


const AutoKYCForm = ({
  open,
  setOpen,
  panCardNumber,
  entityId,
  entityType,
  getBankAccountOfEntity,
  setAutoKycFailed,
  setKycErrorMessage
}) => {

  const { enqueueSnackbar } = useSnackbar();

  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
  };

  const formik = useFormik({
    initialValues: {
      bankAccNumber: "",
      ifscCode: "",
    },
    validationSchema: Yup.object({
      bankAccNumber: Yup.string()
        .required("Account Number is required.")
        .matches(/^\d+$/, "Account Number must be digits only.")
        .min(6, "Account Number must be at least 6 digits.")
        .max(18, "Account Number must be at most 18 digits."),
      ifscCode: Yup.string()
        .required("IFSC code is required.")
        .matches(/^[A-Za-z]{4}0[A-Za-z0-9]{6}$/i, "Enter a valid IFSC code"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const payload = {
          ...values,
          // panCardNumber,
          entityId,
          entityType,
        };

        const res = await bankServices.createBankAccount(payload);
        if (res && res.success) {
          enqueueSnackbar(res?.data?.message || "Bank account created successfully", {
            variant: "success",
          });
          getBankAccountOfEntity();
          resetForm();
          handleClose();
        } else {
          enqueueSnackbar(res?.data?.message || "Something went wrong", { variant: "error" });
          setKycErrorMessage(res?.data?.message || "Something went wrong");
          setAutoKycFailed(true);
        }
      } catch (error) {
        enqueueSnackbar("Something went wrong", { variant: "error" });
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Box padding={1} sx={{ paddingBottom: '0px' }}>
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Add New Bank Account
        </Typography>
        <Divider sx={{ mb: 3 }} />

        <Stack spacing={3}>
          <TextField
            label="Account Number"
            name="bankAccNumber"
            fullWidth
            value={formik.values.bankAccNumber}
            onChange={formik.handleChange}
            error={Boolean(formik.touched.bankAccNumber && formik.errors.bankAccNumber)}
            helperText={formik.touched.bankAccNumber && formik.errors.bankAccNumber}
            onBlur={formik.handleBlur}
          />

          <TextField
            label="IFSC Code"
            name="ifscCode"
            fullWidth
            value={formik.values.ifscCode}
            onChange={formik.handleChange}
            error={Boolean(formik.touched.ifscCode && formik.errors.ifscCode)}
            helperText={formik.touched.ifscCode && formik.errors.ifscCode}
            onBlur={formik.handleBlur}
          />
        </Stack>

        <Stack direction="row" spacing={2} justifyContent="flex-end" mt={4}>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <LoadingButton
            loading={formik.isSubmitting}
            type="submit"
            variant="contained"
            sx={{ mt: 5, width: { md: "auto", xs: "100%" } }}
          >
            Submit
          </LoadingButton>
        </Stack>
      </Box>
    </form>

  )
}

